import { withNavBar } from "../../shared/NavBar/NavBar";
import { RouteNames } from "../../../shared/enums/RouteNames";
import { useHistory } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { SetUserObject } from "../../../store/actions/user/UserActions";
import { ReduxStore } from "../../../store/reducers";

import { useEffect, useState } from "react";
import Localization from "../../../shared/Localization";
import './TermsOfService.scss';
import i18n from "i18n-js";

export interface ITermsOfServiceProps {
  setUserObject: (user: ICognitoUser) => {};
  userObject: ICognitoUser;
}

export function TermsOfService(props: ITermsOfServiceProps) {
  const history = useHistory();

  const [local, setLocal] = useState<typeof i18n | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      const newLocal = await Localization("en");
      setLocal(newLocal);
    };

    fetchData();
  }, []);

  if (!local) return <></>;

  const handleClickLogin = () => {
    history.push(RouteNames.Login);
  }

  const handleAgreeAndSubmit = async () => {
    await Auth.updateUserAttributes(props.userObject, { 'custom:tos-accepted': "true" });
    const newUser = await Auth.currentAuthenticatedUser();
    props.setUserObject(newUser);
    history.push(RouteNames.Home);
  }

  const surrenderText: string[] = local.t("termsOfServicePage.surrenderText") as any;
  const internationalText: string[] = local.t("termsOfServicePage.internationalText") as any;

  return (
    <section className="title">
      <h1 className="main_title">Terms of Service</h1>
      <div className="action_items">
        <button className="cancelbutton" style={{ cursor: 'pointer' }} onClick={handleClickLogin}>CANCEL</button>
        <button className="agreebutton" data-testid="agreeSubmitBtn" onClick={handleAgreeAndSubmit}>AGREE &amp; SUBMIT</button>
      </div>
      <div className="infotext" data-testid="infoText">
        <div className='conditions'>
          <h3 className='conditions-title'>{local.t("termsOfServicePage.conditionsTitle")}</h3>
          <p className='conditions-text'>{local.t("termsOfServicePage.conditionsText")}</p>
        </div>
        <br />
        <div className="surrender">
          <h3 className="surrenderTitle">{local.t("termsOfServicePage.surrenderTitle")}</h3>
          <p className="surrenderText1">{surrenderText[0]}</p>
          <p className="surrenderText2">{surrenderText[1]}</p>
          <ul className='surrenderTextList'>
            <li className="surrenderText3">{surrenderText[2]}</li>
          </ul>
        </div>
        <br />
        <div className="trade">
          <h3 className="tradeTitle">{local.t("termsOfServicePage.tradeTitle")}</h3>
          <p className="tradeText">{local.t("termsOfServicePage.tradeText")}</p>
        </div>
        <br />
        <div className="limited">
          <h3 className="limitedTitle">{local.t("termsOfServicePage.limitedTitle")}</h3>
          <p className="limitedText">{local.t("termsOfServicePage.limitedText")}</p>
        </div>
        <br />
        <div className="website">
          <h3 className="websiteTitle">{local.t("termsOfServicePage.websiteTitle")}</h3>
          <p className="websiteText">{local.t("termsOfServicePage.websiteText")}</p>
        </div>
        <br />
        <div className="details">
          <h3 className="detailsTitle">{local.t("termsOfServicePage.detailsTitle")}</h3>
          <p className="detailsText">{local.t("termsOfServicePage.detailsText")}</p>
        </div>
        <br />
        <div className="international">
          <h3 className="internationalTitle">{local.t("termsOfServicePage.internationalTitle")}</h3>
          <p className="internationalText1">{internationalText[0]}</p>
          <p className="internationalText2">{internationalText[1]}</p>
          <p className="internationalText3">{internationalText[2]}</p>
        </div>
        <br />
        <div className="sale">
          <h3 className="saleTitle">{local.t("termsOfServicePage.saleTitle")}</h3>
          <p className="saleText">{local.t("termsOfServicePage.saleText")}</p>
        </div>
        <br />
        <div className="law">
          <h3 className="lawTitle">{local.t("termsOfServicePage.lawTitle")}</h3>
          <p className="lawText">{local.t("termsOfServicePage.lawText")}</p>
        </div>
        <br />
        <div className="forward">
          <h3 className="forwardTitle">{local.t("termsOfServicePage.forwardTitle")}</h3>
          <p className="forwardText">{local.t("termsOfServicePage.forwardText")}</p>
        </div>

      </div>
    </section>
  );
}

const dispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => ({
  setUserObject: (userObject: ICognitoUser) => dispatch(SetUserObject(userObject))
})

const stateToProps = (state: ReduxStore) => {
  return { userObject: state.User.UserObject }
}

export default withNavBar(connect(stateToProps, dispatchToProps)(TermsOfService));
